$(document).ready(function () {
    activeHeaderScroll();
    burgerMenu();
    sectionNavigation();
    headerHeightFun();
    vhModule();
    $(window).on('resize', function () {
        headerHeightFun();
        vhModule();
    })

    $('.kit__plus').click(function () {
      let item = $(this).closest('.kit__item')
        $('.kit__item.active').not(item).removeClass('active');
        item.toggleClass('active');
    });

    $('.item-faq__visible').click(function () {
        const item = $(this).closest('.item-faq')
        item.toggleClass('active')
        item.find('.item-faq__slide').slideToggle()
    });

    new Swiper('.reviews .swiper', {
        loop: true,
      autoplay: {
        delay: 5000,
      },
        grabCursor: true,
        pagination: {
            el: '.reviews__swiper-pagination',
          clickable: true
        },
    });

  

  new Swiper('.steps__wrap.mobonly .swiper', {
        loop: true,
        autoplay: {
          delay: 5000,
        },
        grabCursor: true,
        pagination: {
            el: '.steps__swiper-pagination',
          clickable: true
        },
    });

    let galleryThumbs = new Swiper(".product__gallery-thumbs", {
        slidesPerView: "auto",
        spaceBetween: 30,
        grabCursor: true,
        watchSlidesProgress: true,
    });

    let gallery = new Swiper(".product__gallery", {
        spaceBetween: 15,
        grabCursor: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: galleryThumbs,
        },
    });

    
});

function sectionNavigation() {
    $(document)
        .on('click', '[href="#"]', function (e) {
            e.preventDefault();
        })
        .on('click', 'a[href^="#section"]', function () {
            let el = $(this).attr('href');
            $('body, html').stop().animate({
                scrollTop: $(el).offset().top - $('.header').outerHeight() - 30
            }, 1000);    
            return false
        })
};

function activeHeaderScroll() {
    let header = $('header.header');
    $(window).on('scroll load', function () {
        if ($(window).scrollTop() >= 10) {
            header.addClass('active');
        } else {
            header.removeClass('active');
        }
    });
}

function burgerMenu() {
    let burger = $('.burger');
    let menu = $('.header__menu');

    $(document).click(function (e) {
        if (burger.is(e.target) || burger.has(e.target).length === 1) {
            if (menu.hasClass('active')) {
                menu.removeClass('active');
                $('body').removeClass('overflow-hidden');
                burger.removeClass('active');
            } else {
                menu.addClass('active');
                $('body').addClass('overflow-hidden');
                burger.addClass('active');
            }
        } else if (!menu.is(e.target) && menu.has(e.target).length === 0 && menu.hasClass('active')) {
            menu.removeClass('active');
            $('body').removeClass('overflow-hidden');
            burger.removeClass('active');
        }
    });

    function changeStateNav() {
        if(window.innerWidth <= 992) {
            menu.addClass('transition');
        } else {
            menu.removeClass('transition');
        }
    }

    window.addEventListener('resize', changeStateNav);
    changeStateNav();
}

function headerHeightFun() {
    let headerHeight = document.querySelector('.header').offsetHeight;
    document.documentElement.style.setProperty('--headerHeight', `${headerHeight}px`);
}

function vhModule() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
}